export enum RoutePaths {
  CL = 'claims/casco-claim',
  CL_APPLICANT_DETAILS = 'casco-applicant-details',
  CL_VEHICLE_EVENT_DETAILS = 'casco-vehicle-event-details',
  CL_CASCO_UPLOADS = 'casco-uploads',
  CL_CASCO_SUMMARY = 'casco-summary',
  CP = 'claims/casco-property',
  CP_APPLICANT_DETAILS = 'property-applicant-details',
  CP_VEHICLE_EVENT_DETAILS = 'property-event-details',
  CP_CASCO_UPLOADS = 'property-uploads',
  CP_CASCO_SUMMARY = 'property-summary',
}
